import { FC, useContext } from 'react'
import AccountDropdown from '../../../common/AccountDropdown'
import { JournalEntriesContext } from '../../../../context/JournalEntriesContext'
import { AccountOption } from '../../../../interfaceTypes/common'

const AccountFilter: FC = () => {
  const { filters, setFilters } = useContext(JournalEntriesContext)

  const handleAccountChange = (option: AccountOption | null) => {
    setFilters({ account: option || undefined })
  }

  return <AccountDropdown value={filters.account || null} onChange={handleAccountChange} />
}

export default AccountFilter
